module.exports = __webpack_public_path__ + "static/media/Angels.b172d0ee.jpg";